import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { CorrespondenceTeamDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-correspondenceteam-container',
  templateUrl: './correspondenceteam-container.component.html',
  styleUrls: ['./correspondenceteam-container.component.scss']
})
export class CorrespondenceteamContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  correspondenceTeams$: Observable<CorrespondenceTeamDto[]>;
  loading: boolean;
  isLoadingCorrespondenceTeam$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
  ) {}

  ngOnInit() {
    this.isLoadingCorrespondenceTeam$ = this.gatwayFacade.isLoadingGateway("CorrespondenceTeam");
    this.correspondenceTeams$ = this.gatwayFacade.loadGateway("CorrespondenceTeam");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteCorrespondenceTeam(deletedValue: any) {
    this.gatwayFacade.remove("CorrespondenceTeam", deletedValue);
  }


// this method control both the create and update

  onSubmitCorrespondenceTeam(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.CorrespondenceTeams;

// declare two empty arrays to hold update and create data
  const allUpdates = [] ;
  const addAllCorrespondenceTeam = [];


// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllCorrespondenceTeam.push(pullData[i]);
    }
  }

// check if the addAllBank array is not empty, then dispatch the data to the store
   if(addAllCorrespondenceTeam.length > 0) {
    this.gatwayFacade.add('CorrespondenceTeam', addAllCorrespondenceTeam);
   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('CorrespondenceTeam', allUpdates, ['id']);
  }

   }


}
